import { SESSION_COUNTDOWN_MS } from 'config'
import { useSessionExpiresAt } from 'shared/components/SessionExpiresAtContext'
import { getSessionExpiryHeldAtMostUntil } from 'shared/utils'
import { useCountdown } from './use-countdown'

// Seconds left until the session expires, or null before the countdown starts
export const useSessionCountdown = () => {
  const sessionExpiresAt = useSessionExpiresAt()

  return useCountdown(
    sessionExpiresAt,
    sessionExpiresAt && sessionExpiresAt - SESSION_COUNTDOWN_MS
  )
}

// Seconds left until an expired session is ended in every tab, though its
// expiry is held, see useIsSessionExpiryPaused. Null before it expires.
export const useSessionEndCountdown = () => {
  const sessionExpiresAt = useSessionExpiresAt()

  return useCountdown(
    getSessionExpiryHeldAtMostUntil(sessionExpiresAt),
    sessionExpiresAt
  )
}
